import { Api } from '../api';
import { alerts } from '../endpoints';
import type { ApiResponse } from '../../models';
import type {
  AddDeclinedAuthRequest,
  AddMinimalBalanceRequest,
  AlertSubscriptionResponse,
  UpdateDeclinedAuthRequest,
  UpdateMinimalBalanceRequest,
} from './models';

export class AlertsApi extends Api {
  static addMinimalBalance = (request: AddMinimalBalanceRequest, signal?: AbortSignal) =>
    this.post<AddMinimalBalanceRequest, ApiResponse<AlertSubscriptionResponse>>({ url: alerts.minimalBalanceAdd(), data: request, signal });

  static addDeclinedAuth = (request: AddDeclinedAuthRequest, signal?: AbortSignal) =>
    this.post<AddDeclinedAuthRequest, ApiResponse<AlertSubscriptionResponse>>({ url: alerts.declinedAuthAdd(), data: request, signal });

  static updateMinimalBalance = ({ subscriptionId, ...data }: UpdateMinimalBalanceRequest, signal?: AbortSignal) =>
    this.put<Omit<UpdateMinimalBalanceRequest, 'subscriptionId'>, ApiResponse<AlertSubscriptionResponse>>({
      url: alerts.minimalBalanceUpdate(subscriptionId),
      data,
      signal,
    });

  static updateDeclinedAuth = ({ subscriptionId, ...data }: UpdateDeclinedAuthRequest, signal?: AbortSignal) =>
    this.put<Omit<UpdateDeclinedAuthRequest, 'subscriptionId'>, ApiResponse<AlertSubscriptionResponse>>({
      url: alerts.declinedAuthUpdate(subscriptionId),
      data,
      signal,
    });

  static deleteSubscription = ({ subscriptionId }: { subscriptionId: string }) =>
    this.delete<null, undefined>({ url: alerts.deleteSubscription(subscriptionId) });
}
